import axios, { CancelTokenSource } from 'axios'
import React, { useEffect, useState } from 'react'
import { Error, getErrorMessageByKey, newUuid } from '../functions'
import { useNotification } from './useNotification'

interface IUseListProps {
  list: [object[] | object[][], number, React.Dispatch<React.SetStateAction<object[] | object[][]>>, number]
  update: [boolean, React.Dispatch<React.SetStateAction<string | boolean>>, () => void]
  page: [
    number,
    React.Dispatch<React.SetStateAction<number>>,
    number,
    React.Dispatch<React.SetStateAction<number>>
  ]
  search: [string, React.Dispatch<React.SetStateAction<string>>]
  url: [string, React.Dispatch<React.SetStateAction<string>>]
  params: [string, React.Dispatch<React.SetStateAction<object>>]
  apiUrl: string
  apiUrlParams: string
  setApiUrl: React.Dispatch<React.SetStateAction<string>>
  setApiUrlParams: React.Dispatch<React.SetStateAction<object>>
}
type UseListProps = IUseListProps

export const useList = (props: {
  apiUrl?: string
  rootUrl?: string
  urlParams?: object | null
  isPagination?: boolean | false
  paginationLimit?: number | 15
  isSearch?: boolean | false
  search?: string | ''
  callbackResponse?: (response: object[] | object[][]) => void
  callbackError?: (error: Error) => void
}): UseListProps => {
  const [list, setList] = useState<object[] | object[][]>(null)
  const [listCount, setListCount] = useState<number>(null)
  const [allCount, setAllCount] = useState<number>(null)
  const [isUpdateList, setIsUpdateList] = useState<string | boolean>(false)
  const [pageNumber, setPageNumber] = useState(1)
  const [pageLimit, setPageLimit] = useState(props.paginationLimit)
  const [searchQuery, setSearchQuery] = useState(props.search)
  const [isRequest, setIsRequest] = useState(false)
  const [cancelTokenSource, setCancelTokenSource] = useState<CancelTokenSource | null>(null)

  const [apiUrl, setApiUrl] = useState(props.apiUrl)
  const [apiUrlParams, setApiUrlParams] = useState<object | null>(props.urlParams)

  const { notification } = useNotification()

  useEffect(() => {
    return () => {
      // console.log('Unmounted')
      setList(null)
      setListCount(null)
      setSearchQuery('')
      // setApiUrlParams(null)
      // setIsRequest(false)
      if (cancelTokenSource) {
        cancelTokenSource.cancel()
      }
    }
  }, [])

  const escapeRegExp = (string: string): string => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') // $& means the whole matched string
  }

  const replaceAll = (str: string, find: string, replace: string): string => {
    return str.replace(new RegExp(escapeRegExp(find), 'g'), replace)
  }

  const getApiUrlParams = (): string => {
    // console.log(apiUrlParams)
    const params: Record<string, string> = {
      ...((!!apiUrlParams && apiUrlParams) || {}),
      ...((props.isSearch && { query: searchQuery || '' }) || {}),
      ...((props.isPagination && {
        page: pageNumber,
        limit: pageLimit
      }) || {})
    } as Record<string, string>

    return replaceAll(new URLSearchParams(params).toString(), '%2C', ',')
  }

  const getApiUrl = (): string => {
    return apiUrl + (getApiUrlParams().length > 0 ? '?' + getApiUrlParams() : '')
  }

  useEffect(() => {
    setPageNumber(1)
    setIsUpdateList(!isUpdateList)
  }, [pageLimit])

  useEffect(() => {
    // console.log(getApiUrl())

    // TODO Доработать механизм залипания запроса.
    // console.log('list: ' + isUpdateList.toString())
    if (isRequest || cancelTokenSource) {
      return
    }
    setIsRequest(true)

    const source = axios.CancelToken.source()
    setCancelTokenSource(source)

    void axios
      .get(
        getApiUrl(),
        {
          withCredentials: false,
          cancelToken: source.token,
          baseURL: props.rootUrl,
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + localStorage.getItem('tokenSession')
          }
        }
      )
      .then((response) => {
        setIsRequest(false)
        setCancelTokenSource(null)
        if (props.callbackResponse) {
          props.callbackResponse(((!!response && !!response.data && response.data) || []) as (object[] | object[][]))
        }
        const count = (props.isPagination
          ? Number(response.headers['total-records'])
          : (!!response && !!response.data && (response.data as (object[] | object[][])).length) || 0)
        setListCount(count)
        if (response.headers['all-records']) {
          const countAll = Number(response.headers['all-records']) || 0
          setAllCount(countAll)
        }
        const list = ((!!response && !!response.data && response.data) || []) as (object[] | object[][])
        setList([...list])
      })
      .catch((error: Error) => {
        setIsRequest(false)
        setCancelTokenSource(null)
        // const errorTag = (
        //   (!!error &&
        //     !!error.response &&
        //     !!error.response.data &&
        //     !!error.response.data.error &&
        //     (error.response.data.error)
        //   ) || '')
        // notification(getErrorMessageByKey(errorTag), 'red')
        if (props.callbackError) {
          props.callbackError(error)
        }
      })
  }, [isUpdateList, apiUrl, apiUrlParams, pageNumber, searchQuery])

  const changeUpdateList = (): void => {
    const uuid = newUuid()
    // console.log('action: ' + uuid)
    setIsUpdateList(uuid)
  }

  return {
    list: [(!!list && list) || null, listCount, setList, allCount] as
      [object[] | object[][], number, React.Dispatch<React.SetStateAction<object[] | object[][]>>, number],
    update: [isUpdateList as boolean, setIsUpdateList, changeUpdateList],
    page: [pageNumber, setPageNumber, pageLimit, setPageLimit],
    search: [searchQuery, setSearchQuery],
    url: [apiUrl, setApiUrl],
    params: [getApiUrlParams(), setApiUrlParams],
    apiUrl,
    apiUrlParams: getApiUrlParams(),
    setApiUrl,
    setApiUrlParams
  }
}
